import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import OfflineBoltOutlinedIcon from '@material-ui/icons/OfflineBoltOutlined';
import WarningIcon from '@material-ui/icons/Warning';
import React from 'react';

const statusIconMap = {
    EFFECTIVE: {
        icon: CheckCircleIcon,
        className: 'num-positive',
        label: 'Effective'
    },
    EFFECTIVE_PENDING: {
        icon: WarningIcon,
        className: 'text-warning',
        label: 'Effective Pending'
    },
    EFFECTIVE_OFFLINE: {
        icon: OfflineBoltOutlinedIcon,
        className: 'text-muted',
        label: 'Effective Offline'
    },
    DELETE_PENDING: {
        icon: ErrorOutlineIcon,
        className: 'num-negative',
        label: 'Delete Pending'
    }
};

export const mmAppointmentsColumnDefs = [
    {
        headerName: '',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 50,
        pinned: 'left',
        lockPosition: true,
        suppressMenu: true,
        sortable: false
    },
    {
        headerName: 'MMID',
        field: 'mmid',
        pinned: 'left',
        width: 100
    },
    {
        headerName: 'Symbol',
        field: 'symbol',
        width: 120
    },
    {
        headerName: 'MM Type',
        field: 'mmType',
        width: 200,
        valueFormatter: ({data}) => data?.mmTypeLabel ?? data?.mmType ?? ''
    },
    {
        headerName: 'Update Status',
        field: 'status',
        width: 180,
        cellRendererFramework: ({data}) => {
            if (!data || !data.status) return null;

            const statusConfig = statusIconMap[data.status];
            if (!statusConfig) return <span>{data.status}</span>;

            const IconComponent = statusConfig.icon;

            return (
                <div className='flex-row flex-align-center flex-grow'>
                    <IconComponent className={statusConfig.className} />
                    &nbsp;{statusConfig.label}
                </div>
            );
        }
    },
    {
        headerName: 'Date/Time',
        field: 'lastUpdatedDate',
        width: 180,
        valueFormatter: ({value}) => {
            if (!value) return '-';
            try {
                const utcDateString = value.endsWith('Z') ? value : value + 'Z';
                return new Date(utcDateString).toLocaleString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    timeZoneName: 'short'
                });
            } catch {
                return value;
            }
        }
    },
    {
        headerName: 'Updated By',
        field: 'updatedBy',
        width: 140
    }
];
